import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const data = [
  {
    sl: 1,
    refType: 'Q',
    refNo: '4201250700000484',
    policyNo: '41010250700000364-00',
    batchNo: '2025080112465156995132168',
    fileName: '4201250700000484.xlsx',
    status: [
      { label: 'Uploaded File', link: '#' },
      { label: 'Feedback File', link: '#' },
    ],
    uploadedBy: 'MR ANIKET MAHADEO MARGI',
    uploadTime: '01 Aug, 2025 12:46 PM',
  },
  {
    sl: 2,
    refType: 'Q',
    refNo: '4201250700000457',
    policyNo: '41010250700000338-00',
    batchNo: '202508011135905357134108',
    fileName: '4201250700000457.xlsx',
    status: [
      { label: 'Uploaded File', link: '#' },
      { label: 'Feedback File', link: '#' },
    ],
    uploadedBy: 'MR ANIKET MAHADEO MARGI',
    uploadTime: '01 Aug, 2025 01:13 PM',
  },
  {
    sl: 3,
    refType: 'Q',
    refNo: '4201250700000402',
    policyNo: '41010250700000331-00',
    batchNo: '202508011135905357134142',
    fileName: '4201250700000457.xlsx',
    status: [
      { label: 'Uploaded File', link: '#' },
      { label: 'Feedback File', link: '#' },
    ],
    uploadedBy: 'MR HARSHAD PATIL',
    uploadTime: '01 Aug, 2025 02:08 PM',
  },
  {
    sl: 4,
    refType: 'Q',
    refNo: '4201250700000455',
    policyNo: '41010250700000333-00',
    batchNo: '202508011135905357134101',
    fileName: '4201250700000457.xlsx',
    status: [
      { label: 'Uploaded File', link: '#' },
      { label: 'Feedback File', link: '#' },
    ],
    uploadedBy: 'MR BHARATA JAISWAL',
    uploadTime: '01 Aug, 2025 04:12 PM',
  },
  {
    sl: 5,
    refType: 'Q',
    refNo: '4201250700000447',
    policyNo: '41010250700000334-00',
    batchNo: '202508011135905357134135',
    fileName: '4201250700000457.xlsx',
    status: [
      { label: 'Uploaded File', link: '#' },
      { label: 'Feedback File', link: '#' },
    ],
    uploadedBy: 'MR AVINASH ARVIND KADAM',
    uploadTime: '01 Aug, 2025 04:28 PM',
  },
];

const MemberUplad = () => {
  const [filterType, setFilterType] = useState('');
  const [uploadDate, setUploadDate] = useState('');
  const [policyCode, setPolicyCode] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openDialogSuccessfull, setOpenDialogSuccessfull] = useState(false);
  const [showDownloadUpload, setShowDownloadUpload] = useState(false);
  const [policyCodeOne, setPolicyCodeOne] = useState('');
  const [file, setFile] = useState(null);
  const [policyNo, setPolicyNo] = useState('');
  const [newUploadDialog, setNewUploadDialog] = useState(false);
  const handleCreate = () => {
    setOpenDialog(true);
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleFileChange = event => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleUpload = () => {
    if (!selectedFile) return alert('Please choose a file first.');
    // Add your file upload logic here
    alert(`Uploading: ${selectedFile.name}`);
  };

  const handleDownload = () => {
    // Replace with actual format file URL
    const link = document.createElement('a');
    link.href = '/path/to/sample_format.xlsx';
    link.download = 'sample_format.xlsx';
    link.click();
  };

  const handleGo = () => {
    if (policyCodeOne === '') {
      alert('Please enter policy code');
      return;
    }
    setShowDownloadUpload(true);
  };

  return (
    <Box>
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        Member Upload
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={2} mt={2}>
        <Box display="flex" alignItems="flex-end" gap="2rem" style={{ display: 'flex', gap: '1rem' }}>
          {/* Filter Type Dropdown */}
          <Box sx={{ width: 220 }}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="filter-type-label">Search By</InputLabel>
              <Select
                labelId="filter-type-label"
                label="Filter By"
                value={filterType}
                onChange={e => setFilterType(e.target.value)}>
                <MenuItem value="">Select...</MenuItem>
                <MenuItem value="policy">Policy Code</MenuItem>
                <MenuItem value="date">Upload Date</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Conditional Inputs */}
          {filterType === 'policy' && (
            <Box>
              <TextField
                label="Policy Code"
                size="small"
                value={policyCode}
                onChange={e => setPolicyCode(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          )}

          {filterType === 'date' && (
            <>
              <Box sx={{ minWidth: 160 }}>
                <TextField
                  label="Upload Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={uploadDate}
                  onChange={e => setUploadDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </>
          )}

          {/* Search Button with extra margin on Date Range */}
          <Box style={{ display: 'flex', gap: '1rem' }}>
            <Button variant="contained" color="primary">
              Search
            </Button>
            <Button variant="contained" color="primary" onClick={handleCreate}>
              New Upload
            </Button>
          </Box>
        </Box>
      </Box>
      <Box style={{ marginTop: '1rem' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, border: '1px solid #ccc' }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#00BFFF' }}>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>#SL</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Ref Type</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Ref No</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Policy No</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Batch No</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>File Name</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Uploaded By</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Upload Time</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(row => (
                <TableRow key={row.sl}>
                  <TableCell>{row.sl}</TableCell>
                  <TableCell>{row.refType}</TableCell>
                  <TableCell>{row.refNo}</TableCell>
                  <TableCell>{row.policyNo}</TableCell>
                  <TableCell>{row.batchNo}</TableCell>
                  <TableCell>{row.fileName}</TableCell>
                  <TableCell>
                    {row.status.map((s, idx) => (
                      <div key={idx}>
                        <Link href={s.link} underline="hover" sx={{ color: '#1976d2', cursor: 'pointer' }}>
                          {s.label}
                        </Link>
                      </div>
                    ))}
                  </TableCell>
                  <TableCell>{row.uploadedBy}</TableCell>
                  <TableCell>{row.uploadTime}</TableCell>
                  <TableCell>
                    <Button variant="contained" size="small">
                      Action
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Dialog
        open={openDialog}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: isSmallScreen
            ? {
                margin: 'auto', // center it on small screens
              }
            : {
                position: 'absolute',
                top: 20,
                // left: 300,
                margin: 0,
              },
        }}>
        <DialogTitle id="form-dialog-title">
          <Box component={Paper} p={2} mb={2} fontWeight="bold">
            Member Data Upload
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContent>
            {!newUploadDialog && (
              <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <Box
                  style={{
                    padding: '8px',
                    gap: '8px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}>
                  <Typography variant="body2" style={{ minWidth: 110, fontWeight: 500 }}>
                    <span style={{ color: 'red' }}>*</span> POLICY CODE :
                  </Typography>

                  <TextField
                    size="small"
                    variant="outlined"
                    value={policyCodeOne}
                    onChange={e => setPolicyCodeOne(e.target.value)}
                    style={{ height: '32px' }} // smaller field height
                    InputProps={{
                      style: { height: 32, padding: '0 8px' }, // controls inside height
                    }}
                  />

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: '#00a0df',
                      color: '#fff',
                      textTransform: 'none',
                      minHeight: '28px', // reduce height
                      padding: '2px 12px', // smaller padding
                      fontSize: '0.8rem',
                    }}
                    onClick={handleGo}>
                    GO
                  </Button>

                  <Button
                    variant="outlined"
                    style={{
                      textTransform: 'none',
                      minWidth: 64,
                      backgroundColor: '#00a0df',
                      color: '#fff',
                      minHeight: '28px',
                      padding: '2px 12px',
                      fontSize: '0.8rem',
                    }}
                    onClick={() => {
                      setOpenDialog(false);
                      setNewUploadDialog(false);
                      setShowDownloadUpload(false);
                      setPolicyCodeOne('');
                    }}>
                    Close
                  </Button>
                </Box>
                {showDownloadUpload && (
                  <Box
                    style={{
                      display: 'flex',
                      borderRadius: '5px',
                      border: '1px solid',
                      borderColor: '#00a0df',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4rem',
                      padding: '4px',
                    }}>
                    {/* Download link */}
                    <Box border={1} borderColor="#00a0df" borderRadius={4} padding="4px 12px" marginRight="4px">
                      <Link
                        component="button"
                        variant="body2"
                        underline="always"
                        onClick={handleDownload}
                        style={{ color: '#00a0df', fontWeight: 500 }}>
                        DOWNLOAD FORMAT
                      </Link>
                    </Box>

                    {/* File input */}
                    <Box
                      border={1}
                      borderColor="#00a0df"
                      borderRadius={4}
                      padding="2px 8px"
                      marginRight="4px"
                      display="flex"
                      alignItems="center">
                      <input type="file" style={{ border: 'none' }} onChange={handleFileChange} />
                    </Box>

                    {/* Upload button */}
                    <Box border={1} borderColor="#00a0df" borderRadius={4}>
                      <Button
                        onClick={handleUpload}
                        disabled={!selectedFile}
                        style={{
                          backgroundColor: '#00a0df',
                          color: '#fff',
                          padding: '2px 12px',
                          textTransform: 'none',
                          minHeight: '24px',
                        }}>
                        Upload
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </DialogContent>
        </DialogContent>
        {/* <DialogActions>
          {newUploadDialog && (
            <Button variant="contained" onClick={handleSave} style={{ backgroundColor: '#00b0f0' }}>
              Save
            </Button>
          )}

          <Button
            variant="contained"
            onClick={() => {
              setOpenDialog(false);
              setNewUploadDialog(false);
            }}
            style={{
              backgroundColor: '#d32f2f',
              color: 'white',
              marginLeft: '1rem',
            }}>
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
      <Dialog open={openDialogSuccessfull} onClose={() => setOpenDialogSuccessfull(false)}>
        <DialogTitle>Policy Created Successfully</DialogTitle>
        <DialogContent style={{ display: 'flex' }}>
          <Typography variant="body1">Your Policy No:</Typography>
          <Typography variant="h6" color="primary" mt={1}>
            {policyNo}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDialogSuccessfull(false)}
            color="primary"
            style={{
              backgroundColor: '#d32f2f',
              color: 'white',
              marginLeft: '1rem',
            }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MemberUplad;
